import { Component, OnInit, ViewChild } from '@angular/core';
import { MongoDbService } from '@core/services/api/mongodb.service';
import { Store, select } from '@ngrx/store';
import { MdbCollapseDirective } from 'mdb-angular-ui-kit/collapse';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { Subscription } from 'rxjs';
import * as CatalogActions from '@core/state/catalog/catalog.actions';
import * as fromCatalog from '@core/state/catalog/catalog.selectors';
import { SharedService } from '@shared/shared.service';

@Component({
  selector: 'app-add-to-cart-modal',
  templateUrl: './add-to-cart-modal.component.html',
  styleUrls: ['./add-to-cart-modal.component.scss']
})
export class AddToCartModalComponent implements OnInit {
  showNewCartInput: boolean = false;
  carts: any;
  cartName: string = '';
  selectedCart: any;
  subscription: Subscription[] = [];
  cartsSubscription: Subscription;
  @ViewChild('basicCollapse') collapse!: MdbCollapseDirective;

  constructor(
    public modalRef: MdbModalRef<AddToCartModalComponent>,
    private sharedService: SharedService,
    private store: Store,
    private _mongo: MongoDbService,
  ) { 

  }

  ngOnInit(): void {
    this.cartsSubscription = this.store.pipe(select(fromCatalog.selectCarts)).subscribe((carts => {
      this.carts = carts
    }));
    this.subscription.push(this.cartsSubscription)
  }

  selectCart(cart) {
    this.selectedCart = cart
    this.close();
  }

  close(): void {
    this.modalRef.close(this.selectedCart)
  }

  openAlert(prompt) {
    this.sharedService.showNotification({ data: { title: prompt, class: '' }, autohide: true });
  }

    /**
   * Asynchronous function to add a new cart.
   */
    async addNewCart() {
      const cart = await this._mongo.cartTemplate()

      if(!this.cartName) {
        this.openAlert('Please input a Cart name.');
      } else {
        cart.cartName = this.cartName;

        this.store.dispatch(CatalogActions.addCart({
          cart: cart
        }));

        this.cartsSubscription = this.store.pipe(select(fromCatalog.selectCarts)).subscribe((carts => {
          this.carts = carts
        }));
        this.subscription.push(this.cartsSubscription)

        this.resetAddNewCart();
      }
    }

    resetAddNewCart() {
      this.cartName = '';
      this.collapse.hide();
    }
  

    ngOnDestroy() {
      this.subscription.forEach((subscription) => subscription.unsubscribe())
  
    }
}
